// @flow

import { ApolloLink, Observable } from 'apollo-link';

import canUseLocalStorage from '../utils/canUseLocalStorage';
import { createCacheKey } from './utils';

import type { NextLink, Operation } from 'apollo-link';

export default class QueryCacheLink extends ApolloLink {
  constructor(storage?: Storage) {
    super();
    if (storage) {
      this.storage = storage;
    } else {
      this.storage = canUseLocalStorage ? require('./storage').default : null;
    }
  }

  request(operation: Operation, forward: NextLink): Observable {
    const nextRequest = forward(operation);
    if (!this.shouldCache(operation)) return nextRequest;

    return new Observable(observer => {
      const subscription = nextRequest.subscribe({
        next: result => {
          try {
            this.writeToCache(operation, result.data);
          } catch (e) {
            this.onWriteError(e);
          }
          observer.next(result);
        },
        error: observer.error.bind(observer),
        complete: observer.complete.bind(observer),
      });

      return () => {
        if (subscription) subscription.unsubscribe();
      };
    });
  }

  shouldCache({ variables }: Operation): boolean {
    return variables.__cacheQuery;
  }

  writeToCache({ operationName, variables }: Operation, data: Object) {
    const cacheKey = createCacheKey(operationName, variables);
    this.storage.setItem(cacheKey, data).catch(this.onWriteError);
  }

  onWriteError(error: Error) {
    console.error(error);
  }
}
